export default "import.meta.ROLLUP_FILE_URL_e24073f2"